import React, { useContext, useEffect } from 'react';
import { AdProviders } from './constants';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { AdContext } from './AdContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
/**
 * Init is used to init the clientside ads
 */ const AdInit = ()=>{
    const { adsEnabled  } = useContext(SessionContext);
    const { DaAds  } = useContext(AdContext);
    const isDaAds = useFlag('ads_da');
    useEffect(()=>{
        if (adsEnabled && DaAds) {
            DaAds.init([
                isDaAds ? AdProviders.Gak : AdProviders.Nitro
            ], window.__ADUNITS__ || []);
        }
    // We only want this to run once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
AdInit.displayName = 'AdInit';
export default AdInit;
